import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Styles from "./Render.module.css";
import { info, Scrollx_animate } from "../../../assets/icons";

import EC_Render from "../../../UiComponents/EC_Render";
import Navbar from "../Navbar/Navbar";
import Navbar_render from "../../../Pages/ProjectV2/Render/Nav_render/Navbar_render";
import RenderSettings from "./RenderSettings";
import RendersTable from "./RendersTable";

import Render_PlanCubeCard from "../../UserPlan/Render_PlanCubeCard";
import AllPlansList from "../../UserPlan/AllPlansList";

import Dropdown_render from "../../../Components/Dropdown/Dropdown_render";
import { Checkbox, NumberInput_render } from "../../../Components";

import {
  renderSettingsOptions,
  fpsNumAndDen,
  commonFps,
  format,
} from "./render.constants";
import html2canvas from "html2canvas";
import dataURItoBlob from "../../../services/dataToBlob";
import { setCurrentNotification } from "../../utils/global";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { increaseRenderCnt } from "../../../Redux/actions/authActions";
import { updatePreviewScale } from "../../../Redux/actions/applicationActions";
import {
  requestRenderXVideo,
  deleteRenders,
  deleteAllRenders,
  downloadRender,
} from "../../../Redux/actions/projectActions";
import ConfirmationModal from "../../../Components/ConfirmationModal/ConfirmationModal";
import {
  getCurrentPlan,
  getRendersPlan,
  getNotification,
  addNotifications,
  getUserAllInformation,
  markRenderDone,
} from "../../../Redux/actions/commonActtion";

import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
} from "../../../Components/CustomToast/CustomToast";

import UpgradePlan from "./UpgradePlan";
import PlanCubeCard from "./PlanCubeCard";
import { generateBlockImages } from "../../utils/generateCreditsPng";

const freeRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
  (resolutionType) => {
    return { label: resolutionType, value: resolutionType };
  },
);
const freeRenderFormats = Object.entries(format).map(([key, value]) => ({
  label: key,
  value: value,
}));
const freeFramRate = commonFps.map((fps) => ({
  label: fps,
  value: 23.976,
}));
const defaultResolution = "1280 x 720";
const mesg =
  "Rendering in Progress Your render is currently being processed. You will receive a notification via email when its complete. Thank you for your patience!";

const RenderNew = ({
  renderOpen,
  setRenderOpen,
  currentBlockIdx,
  isRenderExport,
  setIsRenderExport,
}) => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const dispatch = useDispatch();

  const { isCard, _id } = useSelector((state) => state?.project);
  let { isLoading, renders } = useSelector((state) => state?.project);
  const { renderPlan, subscriptionStatus } = useSelector(
    (state) => state.commonReducer,
  );
  const commonReducer = useSelector((state) => state?.commonReducer);

  const { userData, renderDone, currentPlan } = useSelector(
    (state) => state?.commonReducer,
  );
  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(
    currentPlan.isExpired ? false : true,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsUserPaid(currentPlan.isExpired ? false : true);
  }, [currentPlan.isExpired]);

  // if user is paid, we are getting the settings from local storage, if user is not paid, we are removing the settings from local storage
  let renderSettingData = null;
  if (isUserPaid) {
    renderSettingData = JSON.parse(localStorage.getItem("renderSettings"));
  } else if (!isUserPaid) {
    if (renderSettingData) {
      localStorage.removeItem("renderSettings");
    }
  }
  // const renderSettingFormat = renderSettingData !== null ? renderSettingData.format !== "H264" ? renderSettingData.format.substring(6) : "H264" : "";

  const renderSettingFormat =
    renderSettingData !== null ? renderSettingData.format : "";

  const [loading, setLoading] = useState(false);
  const [isUpgradeOpen, IsUpgradeOpen] = useState(false);
  const [isPlanShow, setIsPlanShow] = useState(false);

  // Getting default settings from local storage, if renderSettings is available otherwise we are taking default setting
  const [resolution, setResolution] = useState(
    renderSettingData !== null
      ? renderSettingData.resolution
      : defaultResolution,
  );
  const [formats, setFormats] = useState(
    renderSettingData !== null ? renderSettingFormat : "H264",
  );
  const [fps, setFps] = useState(
    renderSettingData !== null
      ? renderSettingData.fps
      : renderSettingsOptions[defaultResolution].fps[0],
  );
  const [sppf, setSpps] = useState(
    renderSettingData !== null ? renderSettingData.sppf : 5,
  );
  const [aspectRatio, setAspectRatio] = useState("1.78");

  const [isEmailSend, setIsEmailSend] = useState(true);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const resolutionKeys = Object.keys(renderSettingsOptions);
  const resolutionIndex = resolutionKeys.indexOf(resolution);

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${
        createdAt?.getMonth() + 1
      }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [unsubscribeState, setUnsubscribeState] = useState(false);
  const [buyBackActive, setBuyBackActive] = useState();

  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;
    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
    const purchaseDate = currentPlan?.plan?.createdAt;
    if (purchaseDate) {
      const purchaseTime = new Date(purchaseDate);
      const buyBackTime = new Date(
        purchaseTime.getTime() + 3 * 24 * 60 * 60 * 1000,
      );
      const isBuyBackActive = buyBackTime >= new Date();

      setBuyBackActive(isBuyBackActive);
    }

    dispatch(getUserAllInformation());
  }, []);

  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);
  useEffect(() => {
    const roleName_tr = document.querySelectorAll(".roleName_tr");
    const scrollable = document.querySelectorAll(".scrollable");
    const emptyLogo = document.querySelectorAll(".border-for-empty-logo");
    const bulletClas = document.querySelectorAll(".bullet");
    const RespPreviewClass = document.querySelectorAll(".RespPreviewClass");

    function handleStatusChange() {
      if (roleName_tr) {
        roleName_tr?.forEach((tr) => {
          tr.style.display = "flex";
          tr.style.alignItems = "end";
        });
      }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-for-empty-logo")) {
            el.classList.replace(
              "border-for-empty-logo",
              "border-none-for-empty-logo",
            );
          }
        });
      }
      if (scrollable) {
        scrollable?.forEach((div) => {
          div.style.height = "100vh";
        });
      }
      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "inline-block";
          span.style.backgroundColor = "tranparent";
          span.style.marginTop = "0.05em";
        });
      }
      if (RespPreviewClass) {
        RespPreviewClass?.forEach((div) => {
          div.style.zoom = "1";
        });
      }
    }

    handleStatusChange();
    return function cleanup() {
      if (roleName_tr) {
        roleName_tr?.forEach((tr) => {
          tr.style.display = "flex";
          tr.style.alignItems = "baseline";
        });
      }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-none-for-empty-logo")) {
            el.classList.replace(
              "border-none-for-empty-logo",
              "border-for-empty-logo",
            );
          }
        });
      }
      if (scrollable) {
        scrollable?.forEach((div) => {
          div.style.height = "100%";
        });
      }

      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "flex";
          span.style.justifyContent = "center";
          span.style.alignItems = "center";
        });
      }
      if (RespPreviewClass) {
        RespPreviewClass?.forEach((div) => {
          div.style.zoom = ".8";
        });
      }
    };
  });

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };
  const handleResolutionChange = (val) => {
    setResolution(val);
    if (!renderSettingsOptions[val].fps.includes(fps)) {
      setFps(renderSettingsOptions[val].fps[0]);
    }
    setAspectRatio(renderSettingsOptions[val].aspectRatio);
  };

  const handleFormatChange = (val) => {
    setFormats(val);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };

  // function to get render time according to the png that is being formed from our side;
  const getHeight = () => {
    const { width: videoWidth, height: videoHeight } =
      renderSettingsOptions[resolution];
    const previewScale = videoWidth / 800;
    let blocks = document.querySelectorAll(".blockWrapper");

    const scaledFontSize = 16 * previewScale;
    blocks.forEach((el) => {
      el.style.height = el.clientHeight * previewScale + "px";
      el.style.minHeight = el.clientHeight * previewScale + "px";
      el.style.fontSize = scaledFontSize + "px";
    });

    let totalHeight = 0;
    blocks.forEach((el) => {
      totalHeight += el.offsetHeight;
    });
    totalHeight = totalHeight + 2 * videoHeight;

    let time = totalHeight / (sppf * fps);
    if (videoHeight >= 2000) time -= 20;

    const min = Math.floor(time / 60);
    const sec = Math.floor(time % 60);
    setMin(min);
    setSec(sec);

    blocks.forEach((el) => {
      el.removeAttribute("style");
    });
  };

  // Few Block height iscaling problem
  // const handleExport = async () => {
  //   setLoading(true);
  //   try {
  //     const { width: videoWidth, height: videoHeight } =
  //       renderSettingsOptions[resolution];
  //     const previewScale = videoWidth / 800;
  //     dispatch(updatePreviewScale(previewScale));

  //     const blocks = document.querySelectorAll(".blockWrapper");

  //     const scaledFontSize = 16 * previewScale;

  //     // Store the original dimensions before scaling
  //     const originalHeights = Array.from(blocks).map((el) => el.clientHeight);

  //     blocks.forEach((el) => {
  //       el.style.height =
  //         originalHeights[Array.from(blocks).indexOf(el)] * previewScale + "px";
  //       el.style.minHeight =
  //         originalHeights[Array.from(blocks).indexOf(el)] * previewScale + "px";
  //       el.style.fontSize = scaledFontSize + "px";
  //     });

  //     const scrollPixelPerFrame = sppf;
  //     const { num: fpsNumerator, den: fpsDenominator } = fpsNumAndDen[fps];

  //     const focusedNode = document.getElementById("view_" + currentBlockIdx);
  //     focusedNode?.classList?.remove("focusDiv");
  //     const element = document.getElementById("preview");
  //     element.classList.remove("scrollable");

  //     element.setAttribute(
  //       "style",
  //       `width: ${videoWidth}px;height:100%;background-color: transparent;`,
  //     );

  //     if (!isUserPaid) {
  //       const elementsToHide = document.querySelectorAll(
  //         ".blockWrapper .watermark_displaynone",
  //       );
  //       elementsToHide?.forEach((element) => {
  //         element?.classList?.replace("watermark_displaynone", "watermark");
  //       });
  //     }

  //     await sleep(1000);
  //     const images = [];
  //     for (let idx = 0; idx < blocks.length; idx++) {
  //       const item = blocks[idx];

  //       const canvas = await html2canvas(item, {
  //         backgroundColor: null,
  //         scale: 1,
  //       });
  //       const blob = dataURItoBlob(canvas.toDataURL("image/png", 1.0));
  //       images.push({ blob, idx });
  //     }

  //     // Save render settings to localStorage
  //     localStorage.setItem(
  //       "renderSettings",
  //       JSON.stringify({
  //         resolution: resolution,
  //         format: formats,
  //         sppf: scrollPixelPerFrame,
  //         fps: fps,
  //       }),
  //     );

  //     const renderResult = await dispatch(
  //       requestRenderXVideo(images, {
  //         videoHeight,
  //         videoWidth,
  //         scrollPixelPerFrame,
  //         fpsDenominator,
  //         fpsNumerator,
  //         format: formats === "H264" ? "outputH264" : formats,
  //         aspectRatio: aspectRatio,
  //         isEmailSend: isEmailSend,
  //       }),
  //     );

  //     element.removeAttribute("style");
  //     focusedNode?.classList?.add("focusDiv");
  //     element?.classList?.add("scrollable");

  //     // Restore original styles based on stored heights
  //     blocks.forEach((el, index) => {
  //       el.style.height = originalHeights[index] + "px";
  //       el.style.minHeight = originalHeights[index] + "px";
  //     });

  //     dispatch(updatePreviewScale(1));
  //     dispatch(increaseRenderCnt());

  //     setRenderOpen(false);
  //     setIsRenderExport(true);

  //     if (renderResult?.success) {
  //       toast(<CustomToast title="" content={mesg} />, customToatStyle);
  //       const newRender = renderResult.renders;
  //       const renderId = newRender[newRender.length - 1]._id;

  //       const notifyObj = {
  //         name: "render",
  //         details: newRender[newRender.length - 1],
  //         project_id: _id,
  //         render_id: renderId,
  //         message: `Rendering Completed ${
  //           newRender[newRender.length - 1].videoFilename
  //         }`,
  //         status: 1,
  //         user_id: user._id,
  //       };
  //       setCurrentNotification(notifyObj);
  //       await dispatch(
  //         addNotifications({
  //           project_id: _id,
  //           render_id: renderId,
  //           message: `Render in progress ${
  //             newRender[newRender.length - 1].videoFilename
  //           }`,
  //           status: 1,
  //           user_id: user._id,
  //         }),
  //       );
  //       dispatch(increaseRenderCnt());
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 100);
  //     } else {
  //       toast(<CustomToast title="" content={"Faild"} />, customToatStyle);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  //   setLoading(false);
  // };

  const handleExport = async () => {
    setLoading(true);
    try {
      const { width: videoWidth, height: videoHeight } =
        renderSettingsOptions[resolution];
      const previewScale = videoWidth / 800;

      // Capture DOM references BEFORE dispatching updatePreviewScale.
      // Dispatching first can trigger a React re-render that unmounts #preview,
      // causing a silent TypeError that swallows the entire render request.
      const blocks = document.querySelectorAll(".blockWrapper");
      const scaledFontSize = 16 * previewScale;

      const originalHeights = Array.from(blocks).map((el) => el.clientHeight);

      blocks.forEach((el) => {
        el.style.height =
          originalHeights[Array.from(blocks).indexOf(el)] * previewScale + "px";
        el.style.minHeight =
          originalHeights[Array.from(blocks).indexOf(el)] * previewScale + "px";
        el.style.fontSize = scaledFontSize + "px";
      });

      const scrollPixelPerFrame = sppf;
      const { num: fpsNumerator, den: fpsDenominator } = fpsNumAndDen[fps];

      const focusedNode = document.getElementById("view_" + currentBlockIdx);
      focusedNode?.classList?.remove("focusDiv");
      const element = document.getElementById("preview");

      // Guard: if #preview is missing (e.g. due to an earlier re-render), abort with a visible error.
      if (!element) {
        throw new Error("Preview element not found. Please close and reopen the Render panel and try again.");
      }

      element.classList.remove("scrollable");

      element.setAttribute(
        "style",
        `width: ${videoWidth}px;height:100%;background-color: transparent;`,
      );

      // Now safe to dispatch — DOM references are already captured above.
      dispatch(updatePreviewScale(previewScale));

      if (!isUserPaid) {
        const elementsToHide = document.querySelectorAll(
          ".blockWrapper .watermark_displaynone",
        );
        elementsToHide?.forEach((el) => {
          el?.classList?.replace("watermark_displaynone", "watermark");
        });
      }

      await sleep(1000);

      const images = await generateBlockImages({
        onProgress: (done, total) => {
          console.log(`Captured block ${done}/${total}`);
        },
      });

      localStorage.setItem(
        "renderSettings",
        JSON.stringify({
          resolution,
          format: formats,
          sppf: scrollPixelPerFrame,
          fps,
        }),
      );

      const renderResult = await dispatch(
        requestRenderXVideo(images, {
          videoHeight,
          videoWidth,
          scrollPixelPerFrame,
          fpsDenominator,
          fpsNumerator,
          format: formats === "H264" ? "outputH264" : formats,
          aspectRatio,
          isEmailSend,
        }),
      );

      element.removeAttribute("style");
      focusedNode?.classList?.add("focusDiv");
      element?.classList?.add("scrollable");

      blocks.forEach((el, index) => {
        el.style.height = originalHeights[index] + "px";
        el.style.minHeight = originalHeights[index] + "px";
      });

      dispatch(updatePreviewScale(1));
      dispatch(increaseRenderCnt());
      setRenderOpen(false);
      setIsRenderExport(true);

      if (renderResult?.success) {
        toast(<CustomToast title="" content={mesg} />, customToatStyle);
        const newRender = renderResult.renders;
        const renderId = newRender[newRender.length - 1]._id;

        const notifyObj = {
          name: "render",
          details: newRender[newRender.length - 1],
          project_id: _id,
          render_id: renderId,
          message: `Rendering Completed ${newRender[newRender.length - 1].videoFilename}`,
          status: 1,
          user_id: user._id,
        };
        setCurrentNotification(notifyObj);

        await dispatch(
          addNotifications({
            project_id: _id,
            render_id: renderId,
            message: `Render in progress ${newRender[newRender.length - 1].videoFilename}`,
            status: 1,
            user_id: user._id,
          }),
        );

        dispatch(increaseRenderCnt());
        setTimeout(() => window.location.reload(), 100);
      } else {
        toast(<CustomToast title="" content={"Failed"} />, customToatStyle);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleExportSubmit = () => {
    if (!renderDone && buyBackActive) {
      dispatch(markRenderDone());
    }
    
    if (isUserPaid) {
      handleExport();
    }

    if (!isUserPaid) {
      navigate("/user-plans", {
        state: {
          isRender: true,
          isMoreInfo: false,
          isCard: isCard,
          projectId: projectId ?? null,
        },
      });
      return;
    }
  };

  renders = renders?.sort(
    (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
  );

  const paideRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
    (resolutionType) => {
      return { label: resolutionType, value: resolutionType };
    },
  );
  const paideRenderFormats = Object.entries(format).map(([key, value]) => ({
    label: key,
    value: value,
  }));
  const paidFramRate = renderSettingsOptions[resolution]?.fps?.map((_fps) => ({
    label: _fps,
    value: _fps,
  }));
  const expirationMessage =
    Object.keys(currentPlan).length === 0
      ? "With scrollx watermark"
      : remainingDays === 0
        ? "Plan Expired"
        : remainingDays === 1 || validityValue === 1
          ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
          : remainingDays > 1
            ? `Remaining ${remainingDays} days`
            : "";

  function addIntervalToPurchaseDate(
    planPurchaseDate,
    interval_count,
    interval_type,
  ) {
    const purchaseDate = planPurchaseDate; // Convert purchase date to Date object

    // Check if the purchase date is valid
    if (isNaN(purchaseDate)) {
      return null;
    }

    // Based on the interval_type, add to the date accordingly
    switch (interval_type) {
      case "day":
        purchaseDate.setDate(purchaseDate.getDate() + interval_count);
        break;
      case "month":
        purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
        break;
      case "year":
        purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
        break;
      default:
        throw new Error("Invalid interval type");
    }

    // Return date in YYYY-MM-DD format
    return purchaseDate;
  }

  const expirationDate =
    currentPlanDetails !== null
      ? addIntervalToPurchaseDate(
          createdAt,
          currentPlanDetails?.interval_count,
          currentPlanDetails?.interval,
        )
      : new Date();

  const expiryString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Expiration Date ${expirationDate.getDate()}/${
          expirationDate.getMonth() + 1
        }/${expirationDate.getFullYear()}`
      : "";

  const renewalString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Renewal Date ${expirationDate.getDate()}/${
          expirationDate.getMonth() + 1
        }/${expirationDate.getFullYear()}`
      : "";

  const currentDate = new Date();
  const isPlanActive = currentDate < expirationDate;

  useEffect(() => {
    getHeight();
  }, [sppf, fps, resolution]);

  return (
    <>
      {/* <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        message="By clicking 'Render', you agree that the 3-day money-back guarantee will be void. Are you sure you want to continue?"
      /> */}
      <EC_Render isOpen={renderOpen} closeModal={() => setRenderOpen(false)}>
        {loading ? (
          <div className={Styles.modalOverlayLoader}>
            <img
              src={Scrollx_animate}
              className="absolute opacity-80"
              width="120px"
              height="120px"
            />
            <p className="mt-[8rem] text-[0.9rem] text-white">
              Requesting Video ...
            </p>
          </div>
        ) : null}

        <div className="w-full h-full">
          <div className="renderHead">
            <Navbar_render closeModal={() => setRenderOpen(false)} />
            {/* <Navbar renderOpen={renderOpen} setRenderOpen={setRenderOpen} /> */}
          </div>

          <div className={Styles.PageContainer}>
            <div className={Styles.renderUpperContainer}>
              <div className={Styles.renderContainer}>
                <div className={Styles.mainContainer}>
                  <div className={Styles.renderSettings}>
                    <div className="w-[90%] flex justify-between pt-[5px] pb-[10px]  border-b-[1px]  border-[#373843]">
                      <div>
                        <h1 className="manrope-800 capitalize  lg:text-[1.5rem] text-[0.9rem] text-white">
                          Select Render Settings{" "}
                        </h1>
                      </div>
                      <div className="flex items-center">
                        <img
                          className="w-5"
                          src={info}
                          alt=""
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            window.open(`/help/6708ed7949a4f8d9d07c0466`)
                          }
                        />
                      </div>
                    </div>
                    <div className={Styles.mainSettingsScroll}>
                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Resolution</label>
                        <Dropdown_render
                          isUserPaid={isUserPaid}
                          options={
                            isUserPaid
                              ? paideRenderSettingsOptions
                              : freeRenderSettingsOptions
                          }
                          value={
                            isUserPaid
                              ? `${resolution}`
                              : freeRenderSettingsOptions[0]?.label
                          }
                          onChange={(value) => {
                            isUserPaid && handleResolutionChange(value);
                          }}
                          resolutionIndex={resolutionIndex}
                          IsUpgradeOpen={IsUpgradeOpen}
                        />
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Format</label>
                        <Dropdown_render
                          isUserPaid={isUserPaid}
                          options={
                            isUserPaid ? paideRenderFormats : freeRenderFormats
                          }
                          value={formats}
                          onChange={(value) => {
                            isUserPaid && handleFormatChange(value);
                          }}
                          IsUpgradeOpen={IsUpgradeOpen}
                        />
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Frame Rate</label>
                        <Dropdown_render
                          isUserPaid={isUserPaid}
                          options={isUserPaid ? paidFramRate : freeFramRate}
                          value={fps}
                          onChange={setFps}
                          IsUpgradeOpen={IsUpgradeOpen}
                        />
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className="">
                          Speed <span>(px/frame)</span>
                        </label>
                        <div className={Styles.marginSet}>
                          <NumberInput_render
                            value={sppf}
                            onChange={setSpps}
                            min={1}
                            max={10}
                          />
                        </div>
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthframe}>
                          Running Time
                        </label>
                        <div
                          className={Styles.renderTime}
                          style={{
                            border: "1px solid gray",
                            marginBottom: "2px",
                          }}
                        >
                          <div>
                            <span className="mr-1">
                              {String(min).padStart(2, "0")}
                              <span>{" :"}</span>
                            </span>
                            <span>{String(sec).padStart(2, "0")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-[90%] py-2 items-center justify-between">
                      <div className="">
                        <div
                          className={Styles.ExportBtn}
                          onClick={handleExportSubmit}
                          // onClick={()=>( window.open("/paymentsuccess", '_blank'))}
                          disabled={isLoading && loading}
                        >
                          <span className="manrope-800 "> Render</span>
                        </div>
                      </div>
                      <div className={Styles.settingsOptionBtnScroll}>
                        <Checkbox
                          isEmailSend={isEmailSend}
                          setIsEmailSend={setIsEmailSend}
                        />
                        <label className={Styles.checkboxLabel}>
                          Email me when render is complete
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <RenderSettings isCard={isCard} IsUpgradeOpen={IsUpgradeOpen} isUserPaid={isUserPaid} paideRenderSettingsOptions={paideRenderSettingsOptions} freeRenderSettingsOptions={freeRenderSettingsOptions} resolution={resolution} handleResolutionChange={handleResolutionChange} resolutionIndex={resolutionIndex} paideRenderFormats={paideRenderFormats} freeRenderFormats={freeRenderFormats} formats={formats}
                handleFormatChange={handleFormatChange} paidFramRate={paidFramRate} freeFramRate={freeFramRate} fps={fps} setFps={setFps} sppf={sppf} setSpps={setSpps} min={min} sec={sec} handleExportSubmit={handleExportSubmit} isLoading={isLoading}
                loading={loading} isPlanActive={isPlanActive} renderCnt={renderCnt} isEmailSend={isEmailSend} setIsEmailSend={setIsEmailSend}
                /> */}
              </div>

              <div className={Styles.renderContainer}>
                <Render_PlanCubeCard
                  isPlanShow={isPlanShow}
                  setIsPlanShow={setIsPlanShow}
                />

                {/* <PlanCubeCard
                    iscurrentPlanActivate={iscurrentPlanActivate}
                    lable={
                      isPlanActive
                        ? `${
                            currentPlanDetails?.interval_count === 7
                              ? "Weekly"
                              : currentPlanDetails?.interval_count === 30
                              ? "Monthly"
                              : ""
                          } ${currentPlanDetails?.type} Plan`
                        : "Basic Plan"
                    }
                    currentPlan={
                      currentPlanDetails?._id
                        ? currentPlanDetails?.type
                        : "Free"
                    }
                    rendersLimit={
                      isPlanActive
                        ? currentPlanDetails?.text1
                        : "Limited scroll and card renders with watermark"
                    }
                    projectLimits={
                      isPlanActive ? currentPlanDetails?.text2 : ""
                    }
                    support={
                      currentPlanDetails?._id
                        ? "Support " + currentPlanDetails?.text4
                        : "Only support 720p"
                    }
                    validity={
                      currentPlanDetails?._id
                        ? "validity " + currentPlanDetails?.validity
                        : ""
                    }
                    planRenueDate={expirationMessage}
                    expiryString={expiryString}
                    renewalString={renewalString}
                    planPurchaseDate={planPurchaseDate}
                    buttonLable={"Upgrade"}
                    onClick={() => IsUpgradeOpen(true)}
                    paymentType={currentPlan?.plan?.payment_type}
                    order_id={currentPlan?.plan?.order_id}
                    subscription_status={currentPlan?.plan?.subscription_status}
                  /> */}
              </div>
            </div>

            <div className={Styles.renderDownContainer}>
              <RendersTable isCard={isCard} />
            </div>
          </div>
          {/* {isUpgradeOpen && (
            <UpgradePlan
              isUpgradeOpen={isUpgradeOpen}
              IsUpgradeOpen={IsUpgradeOpen}
              renderPlan={renderPlan}
              currentPlanDetails={currentPlanDetails}
              remainingDays={remainingDays}
              setRenderOpen={setRenderOpen}
              planPurchaseDate={planPurchaseDate}
              expirationMessage={expirationMessage}
              getTime={getTime}
              setIsSuccessOpen={setIsSuccessOpen}
              paymentType={currentPlan?.plan?.payment_type}
              order_id={currentPlan?.plan?.order_id}
              subscription_status={currentPlan?.plan?.subscription_status}
            />
          )} */}

          {isPlanShow && (
            <AllPlansList
              setRenderOpen={setRenderOpen}
              isPlanShow={isPlanShow}
              setIsPlanShow={setIsPlanShow}
            />
          )}
        </div>
      </EC_Render>
    </>
  );
};

export default RenderNew;
